import "core-js/modules/es.array.join";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.string.split";
import { isDefined, isObject } from './verify';
export function deepAssign(path, base, value) {
  if (path === '') {
    throw new Error('Cannot assign with empty path');
  }

  var levels = path.split(/\./);
  var final = levels.pop();
  var current = levels.reduce(function (visitor, level, idx) {
    if (!isObject(visitor)) {
      throw new Error("Cannot traverse past ".concat(levels.slice(0, idx).join('.')));
    }

    return visitor[level] = visitor[level] || {};
  }, base);
  return current[final] = value;
}
export function deepExtract(path, base, defaultValue) {
  var result = path === '' ? base : path.split(/\./).reduce(function (visitor, level) {
    return isObject(visitor) ? visitor[level] : undefined;
  }, base);
  return isDefined(result) ? result : defaultValue;
}